import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Article from 'components/Article'

const Terms = () => {
  return (
    <Article headline="Terms of Use">
      <Box my={3}>
        <Typography variant="h5">
          At DHI ("DHI", "we" or “us”) data protection and confidentiality is a
          high priority. This privacy policy sets out clear guidelines for how
          DHI processes your personal data. Further, we explain how we use the
          personal data that you leave and/or provide when you visit our
          websites or when you interact with us with various business relations.
        </Typography>
      </Box>
      <Box my={3}>
        <Typography variant="h5">
          The Terms addresses your legal rights and obligations and includes
          important disclaimers and choice of law and forum provisions. Please
          read carefully. The Terms apply to all websites of DHI Group,
          including sites for registered users.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          OWNERSHIP OF THE WEBSITE
        </Typography>
        <Typography variant="body2">
          The website is owned and operated by DHI (referred as we/us in these
          Terms), a corporation incorporated under the laws of Denmark, having
          its principal office in Hørsholm.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          USE LICENSE
        </Typography>
        <Typography variant="body2">
          Please feel free to browse the website. We grant you permission to
          view this website and to print or download material displayed on the
          website for your own personal, non-commercial use, provided that you
          agree to and accept without modification the notices, terms and
          conditions set forth in this agreement and provided that you keep
          intact all copyright, trademark and other proprietary notices. You may
          not however copy, reproduce, republish, upload, transmit or distribute
          in any way the contents of this website, including the text, images,
          audio and video for public or commercial purposes, without written
          permission from us. You are also prohibited from using any content of
          this website in a frame on any other internet site in any way.
        </Typography>
        <Typography>
          Your use of this website constitutes your agreement and acceptance
          without modification of the notices, terms and conditions set forth
          herein. In addition as a condition of your use of this website, you
          represent and warrant to us that you will not use this website for any
          purpose that is unlawful, immoral or prohibited by these terms,
          conditions and notices.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          USER SUBMISSIONS
        </Typography>
        <Typography variant="body2">
          Any communication or material that you transmit to the website by
          e-mail or otherwise is, and will be treated as non-confidential and
          non-proprietary information. Anything you transmit or post may be used
          by us for any purpose. You are prohibited from posting or transmitting
          to or from this Site any unlawful, threatening, libellous, defamatory,
          obscene, pornographic, or other material that may violate any law.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          LINKS TO AND FROM OTHER MATERIALS
        </Typography>
        <Typography variant="body2">
          We may provide hyperlinks to third party sites. The linked sites are
          not under our control and in no way are we responsible for the content
          of any such linked site or for the content of any site linked to such
          linked site. We do not endorse companies or products to which it may
          provide hyperlinks and we reserve the right to note as such on our
          Site. We reserve the unilateral right to terminate any link or linking
          program at any time. If you decide to access any of the third party
          sites linked to this website, you do so at your own risk. Third
          parties may only provide hyperlinks to our main homepage. Any links to
          underlying sites require a prior written approval from us.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          CONTENT
        </Typography>
        <Typography variant="body2">
          We take great care in creating and maintaining this website, and in
          providing accurate and up-to-date content. However, the content of
          this website is subject to frequent modifications without prior
          notice. Therefore, we do not guarantee the correct and actual status
          of said content. The visitors to the website accept our exoneration of
          any liability whatsoever for the content of the website, the software
          on the website or for any use made of it.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          INTELLECTUAL PROPERTY
        </Typography>
        <Typography variant="body2">
          The texts, layouts, drawings, databases and other items on this
          website, as well as the website itself, are protected by copyright and
          by the right of the producer of the database. Some of the names, signs
          and logos on this website are protected trademarks or trade names.
          Nothing contained on the website should be construed as granting any
          license or right to use any trademark, displayed on the website
          without the written permission from us or such third party that may
          own the trademarks displayed on the website. Any copy, adaptation,
          translation, arrangement, modification, or any use whatsoever of the
          whole or of any part of this website of its protected elements, in any
          form and by any means, is strictly prohibited.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          DATA PROTECTION
        </Typography>
        <Typography variant="body2">
          We collect and process information on the behaviour of the users of
          this Site for statistical and marketing purposes. The user has the
          right to oppose, free of charge, the processing for marketing purposes
          of the data concerning him, and has the right to access personal data
          and correct such data. For more information regarding the data that we
          collect and the measures we take to protect the privacy of our user
          data please refer to our Privacy Policy.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          LIABILITY
        </Typography>
        <Typography variant="body2">
          Your use of and browsing in this Site is at your own risk. DHI does
          not warrant that the software used for this Site, and the information,
          the on-line applications, or any other services provided by means of
          this Site are error-free, or that their use will be uninterrupted. DHI
          expressly disclaims all warranties related to the above-mentioned
          subject matter, including, without limitation, those of accuracy,
          condition, merchantability and fitness for particular purpose.
          Notwithstanding anything to the contrary in this Site, in no event
          shall DHI be liable for any loss of profits, revenues, indirect,
          special, incidental, consequential, or other similar damages arising
          out of or in connection with this Site or out of the use of any of the
          services proposed by means of this Site.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          PRODUCT ORDERS
        </Typography>
        <Typography variant="body2">
          While we will use our best efforts to fulfill all orders, we cannot
          guarantee the availability of any particular product displayed on this
          website. We reserve the right to discontinue the sale of any product
          listed on this website at any time without notice.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          UPDATES
        </Typography>
        <Typography variant="body2">
          We reserve the unilateral right to update, modify, change and alter
          our Terms and Privacy Policy at any time. All such updates,
          modifications, changes and alterations are binding on all users and
          browsers of our website and will be posted here.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          SOFTWARE LICENSES
        </Typography>
        <Typography variant="body2">
          You shall have no rights to the proprietary software and related
          documentation, or any enhancements or modifications thereto, which may
          be provided to you in order to access specified areas within the
          website. You may not sublicense, assign or transfer any licenses
          granted by us, and any attempt at such sublicense, assignment or
          transfer shall be null and void. You may not otherwise copy,
          distribute, modify, reverse engineer, or create derivative works from
          such software.
        </Typography>
      </Box>
      <Box py={1}>
        <Typography gutterBottom variant="h6">
          CHOICE OF LAW AND FORUM PROVISIONS
        </Typography>
        <Typography variant="body2">
          This website resides on a server in Hørsholm, Denmark. You agree that
          these Terms and your use of this website are governed by the laws of
          Denmark. You hereby consent to the jurisdiction and venue of the
          Municipal Court of Lyngby, Denmark in all disputes (a) arising out of,
          relating to, or concerning this website and/or these Terms, (b) in
          which this website and/or these Terms is an issue or a material fact,
          or (c) in which this website and/or these Terms is referenced in a
          paper filed in a court, tribunal, agency or other dispute resolution
          organisation. We have endeavoured to comply with all legal
          requirements known to us in creating and maintaining this website, but
          make no representation that materials on this website are appropriate
          or available for use in any particular jurisdiction. You are
          responsible for compliance with applicable laws. Any use in
          contravention of this provision or any provision of these Terms is at
          your own risk and, if any part of these Terms is invalid or
          unenforceable under applicable law, the invalid or unenforceable
          provision will be deemed superseded by a valid, enforceable provision
          that most closely matches the intent of the original provision and the
          remainder of these Terms shall govern such use.
        </Typography>
      </Box>
    </Article>
  )
}

export default Terms
